/* TIKUN — הדמיה תלת־ממדית של קופת 770 עם כיתוב חי · v10
   v10 (פידבק איתן): גם כרטיס "עיצוב מותאם אישית" עבר לעורך — בעמוד המוצר יש רק את הכפתור ·
   GLB v7: הוסרו לוחיות התפר שריחפו מחוץ לגוף ונראו כשתי לוחיות חומות על הפלינת'.
   v9: הכיתוב בברירת מחדל בגודל הגדול ביותר שנכנס באזור (סליידר 50%-100% רק מקטין) ·
   כרטיסי הכיתוב הוסרו מעמוד המוצר · סיכום חי על הכפתור · מכסה תחתית כהה + maxPolarAngle π·0.53.
   v8: אין הדמיה קטנה בעמוד המוצר — כניסה אחת לעורך דרך הכפתור (בלי חלונית ביניים, בלי כפתור מסך-מלא) ·
   GLB v5 עם קופסת הסתרה כהה (Occluder) — חריץ המטבעות וחור התלייה לא חושפים את החלל.
   v7: מודל GLB מוגן (גוף אחד, חלול, בלי תחתית, סימן מים) · 5 מיקומים (בלי גב הבסיס) · 5 אפשרויות כיתוב קדמי ·
   הגבלת זווית מצלמה. v6: פונט Taamey Frank CLM · בורר מידה+צבע · לוגו TIKUN בעורך.
   v5: פלינת' כהה כמו בצילומי המוצר · חריטה ריאליסטית בגוון המשטח (לא אפור) ·
   טקסט נפרד + גודל נפרד לכל אחד מ-6 המיקומים (זוגות סימטריים מסונכרנים בווידג'ט) ·
   הכיתוב הקבוע בחזית: "770 EASTERN PARKWAY N.Y." / "770" לפי הצ'קבוקסים · סימון הכיתוב פותח חלונית "המשך" שמובילה לעורך במסך מלא ·
   העורך במסך מלא מכיל את כל הכרטיסים האמיתיים (טקסטים, גדלים, חזית, עיצוב מיוחד) — בלי שכפול שדות.
   לקחים קבועים: CanvasTexture אחרי שינוי מידות קנבס — טקסטורה חדשה בכל ציור (texStorage2D) · צבעים דרך convertSRGBToLinear (r147). */
(function () {
  var C = window.TIKUN_ENGRAVE;
  var D = window.TIKUN_3D;
  if (!C || !C.is770 || !D || !D.glb) return;

  var RTL = !!C.rtl;
  var FRONT_FULL = '770 EASTERN PARKWAY N.Y.';
  var FRONT_YECHI = 'יחי אדוננו מורנו ורבינו מלך המשיח לעולם ועד';
  var FRONT_TZEDAKA = 'צדקה';
  var T = RTL
    ? {
        lead: 'סובבו עם העכבר או האצבע · גלגלת = זום · לחיצה על הגלגלת = הזזה.',
        loading: 'טוען את הקופה…',
        err: 'ההדמיה לא נטענה — נסו לרענן את העמוד.',
        note: 'הכיתוב נחרט בחומר עצמו, בלי צבע. "הדגשת הכיתוב" רק מבליטה אותו על המסך. לפני הייצור נשלח הדמיה מדויקת לאישור.',
        hint: 'הקלידו נוסח באחד המיקומים — הוא יופיע כאן על הקופה.',
        modeReal: 'חריטה כמו במציאות',
        modeClear: 'הדגשת הכיתוב',
        full: 'עריכה במסך מלא ⛶',
        fullExit: 'סגירה ✕',
        dlgTitle: 'הדמיית החריטה — קופת 770',
        introTtl: 'רואים את החריטה על הקופה — בתלת־ממד',
        introTxt: 'בעורך המלא כותבים את הנוסח בכל מיקום, בוחרים גודל, ורואים הכל חי על הקופה.',
        introGo: 'המשך לעורך ⛶',
        introSkip: 'אולי אחר־כך',
        cta: 'עצבו את הקופה האישית שלכם ✨',
        ctaSub: 'כיתוב חרוט · מיקום, גודל וצבע · בקשות עיצוב מיוחדות · 49 ₪ לחלק',
        ctaEdit: 'עריכת העיצוב שלכם ✎',
        sumOne: 'כיתוב אחד',
        sumMany: '[k] כיתובים',
        sumBoth: 'שני חלקים',
        sumDesign: 'בקשת עיצוב מיוחד',
        pickTtl: 'מידה וצבע',
        pickSize: 'מידה',
        pickColor: 'צבע',
        dimLbl: 'מידות המוצר',
        dimOrder: 'רוחב × גובה × עומק'
      }
    : {
        lead: 'Rotate with your mouse or finger · scroll to zoom · press the wheel to pan.',
        loading: 'Loading the model…',
        err: 'The preview failed to load — try refreshing the page.',
        note: 'The engraving is carved into the material itself — no color. "Highlight" only makes it easier to read on screen. We send an exact proof before production.',
        hint: 'Type a text in one of the locations — it will appear here on the box.',
        modeReal: 'True engraving',
        modeClear: 'Highlight text',
        full: 'Edit fullscreen ⛶',
        fullExit: 'Close ✕',
        dlgTitle: 'Engraving preview — 770 box',
        introTtl: 'See the engraving on the box — in 3D',
        introTxt: 'In the full editor you type the text for each location, pick a size, and see it all live on the box.',
        introGo: 'Continue to the editor ⛶',
        introSkip: 'Maybe later',
        cta: 'Design your own tzedakah box ✨',
        ctaSub: 'Engraved text · location, size & color · custom design requests · ₪49 per part',
        ctaEdit: 'Edit your design ✎',
        sumOne: '1 engraving',
        sumMany: '[k] engravings',
        sumBoth: 'both parts',
        sumDesign: 'custom design request',
        pickTtl: 'Size & color',
        pickSize: 'Size',
        pickColor: 'Color',
        dimLbl: 'Product dimensions',
        dimOrder: 'width × height × depth'
      };

  // מיקומי הכיתוב (Y-up, מ"מ) — אינדקס = data-tkloc. הכיתוב ישירות על הגוף (v7: בלי גב הבסיס)
  var LOCS = [
    { pos: [0, -58.5, 29.95],  rotY: 0,            w: 120, h: 12, cam: [0, 0, 268],    tgt: [0, -25, 0], base: true },
    { pos: [80.4, -58.5, 4],   rotY: Math.PI / 2,  w: 40,  h: 10, cam: [262, -5, 55],   tgt: [30, -40, 0], base: true },
    { pos: [-80.4, -58.5, 4],  rotY: -Math.PI / 2, w: 40,  h: 10, cam: [-262, -5, 55],  tgt: [-30, -40, 0], base: true },
    { pos: [-44, 14, -22.0],   rotY: Math.PI,      w: 52,  h: 26, cam: [-35, 40, -245], tgt: [-15, 5, 0], base: false },
    { pos: [44, 14, -22.0],    rotY: Math.PI,      w: 52,  h: 26, cam: [35, 40, -245],  tgt: [15, 5, 0], base: false }
  ];
  var COLORS = {
    'זהב':   { c: 0xb8862b, m: 0.85, r: 0.34 },
    'כסף':   { c: 0xb4b8be, m: 0.85, r: 0.3 },
    'נחושת': { c: 0xa14e18, m: 0.85, r: 0.36 }
  };
  var DEFAULT_COLOR = 'זהב';
  // הפלינת': שוקולד כהה־אדמדם כמו בצילומי המוצר
  var BASE_COLOR = 0x2a1810;
  // אותו פונט שחורט בפועל בפיוזן
  var FONT_URL = D.font || 'https://cdn.shopify.com/s/files/1/0946/0786/8219/files/TaameyFrankCLM-Medium.ttf?v=1786257009';
  var FONT_STACK = '"TaameyFrankCLM", "Taamey Frank CLM", Georgia, "Times New Roman", serif';
  var LOGO_URL = 'https://cdn.shopify.com/s/files/1/0946/0786/8219/files/tikun-logo-horizontal.png?v=1785233000';
  var SWATCH = { 'זהב': '#c9973f', 'כסף': '#b4b8be', 'נחושת': '#a14e18' };
  // מידות חיצוניות בס"מ (רוחב × גובה × עומק) — נמדדו מ-770 CUSTOM בפיוזן, 9.8.2026
  var DIMS = {
    'קטן':   [12.8, 12.9, 4.1],
    'בינוני': [16.0, 16.2, 5.1],
    'גדול':  [19.7, 19.9, 6.3],
    'ענק':   [25.8, 26.1, 8.3],
    'Small':  [12.8, 12.9, 4.1],
    'Medium': [16.0, 16.2, 5.1],
    'Large':  [19.7, 19.9, 6.3],
    'Giant':  [25.8, 26.1, 8.3]
  };
  function dimText(sizeLbl) {
    var d = DIMS[sizeLbl];
    if (!d) return '';
    function n(v) { return (Math.round(v * 10) / 10).toFixed(1).replace(/\.0$/, ''); }
    return n(d[0]) + ' × ' + n(d[1]) + ' × ' + n(d[2]) + (RTL ? ' ס״מ' : ' cm');
  }

  var SCRIPTS = [
    'https://cdn.jsdelivr.net/npm/three@0.147.0/build/three.min.js',
    'https://cdn.jsdelivr.net/npm/three@0.147.0/examples/js/controls/OrbitControls.js',
    'https://cdn.jsdelivr.net/npm/three@0.147.0/examples/js/loaders/GLTFLoader.js',
    'https://cdn.jsdelivr.net/npm/meshoptimizer@0.18.1/meshopt_decoder.js'
  ];

  function el(tag, cls, txt) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (txt != null) n.textContent = txt;
    return n;
  }

  function css() {
    if (document.getElementById('tikun-3d-css')) return;
    var s = document.createElement('style');
    s.id = 'tikun-3d-css';
    s.textContent =
      /* v8: ההדמיה חיה רק בעורך המלא — בעמוד המוצר הכל מוסתר */
      '.tk3dp{margin-top:12px}' +
      '.tk3dp__lead{display:none;margin:0 0 8px;font-size:1.25rem;color:#8a7a55}' +
      '.tk3dp__dlgside .tk3dp__lead{display:block}' +
      '.tk3dp__bar{display:none;gap:8px;margin:0 0 8px;flex-wrap:wrap;align-items:center}' +
      '.tk3dp__dlgside .tk3dp__bar{display:flex}' +
      '.tk3dp__mode{flex:0 0 auto;font:inherit;font-size:1.2rem;font-weight:600;padding:6px 13px;border-radius:999px;border:1.5px solid #2E3A54;background:#fffdf6;color:#2E3A54;cursor:pointer}' +
      '.tk3dp__mode.is-on{background:#2E3A54;color:#FBF6E9}' +
      '.tk3dp__fs{flex:0 0 auto;margin-inline-start:auto;font:inherit;font-size:1.2rem;font-weight:600;padding:6px 13px;border-radius:999px;border:1.5px solid #8FA3C4;background:#fffdf6;color:#2E3A54;cursor:pointer}' +
      '.tk3dp__stage{position:relative;display:none}' +
      '.tk3dp__dlg .tk3dp__stage{display:block}' +
      '.tk3dp__canvas{width:100%;height:340px;border-radius:10px;background:radial-gradient(ellipse at 50% 28%,#46577c 0%,#2E3A54 55%,#202939 100%);touch-action:none;display:block;cursor:grab;border:1px solid #24304a}' +
      '.tk3dp__canvas:active{cursor:grabbing}' +
      '.tk3dp__load{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;color:#FBF6E9;font-weight:600;pointer-events:none}' +
      '.tk3dp__hint{position:absolute;bottom:10px;right:12px;left:12px;text-align:center;color:#FBF6E9;font-size:1.25rem;pointer-events:none;text-shadow:0 1px 3px rgba(0,0,0,.6)}' +
      '.tk3dp__note{display:none;margin:8px 0 0;font-size:1.2rem;color:#8a7a55}' +
      '.tk3dp__dlgside .tk3dp__note{display:block}' +
      /* כפתור כניסה גדול בדף המוצר */
      '.tk3dp__cta{display:block;width:100%;box-sizing:border-box;margin:0 0 18px;padding:16px 18px;border:none;border-radius:14px;cursor:pointer;text-align:center;font:inherit;background:linear-gradient(135deg,#2E3A54 0%,#3d4e73 55%,#2E3A54 100%);color:#FBF6E9;box-shadow:0 4px 16px rgba(46,58,84,.35);transition:transform .12s,box-shadow .12s}' +
      '.tk3dp__cta:hover{transform:translateY(-1px);box-shadow:0 6px 22px rgba(46,58,84,.45)}' +
      '.tk3dp__cta b{display:block;font-size:1.7rem;font-weight:700;letter-spacing:.02em}' +
      '.tk3dp__cta span{display:block;margin-top:5px;font-size:1.2rem;color:#c9d3e6}' +
      '.tk3dp__cta i{display:none;margin-top:9px;padding-top:8px;border-top:1px solid rgba(251,246,233,.28);font-style:normal;font-size:1.25rem;font-weight:700;color:#ffe6ab}' +
      '.tk3dp__cta.is-set i{display:block}' +
      /* בעמוד המוצר מוצגים רק הכפתור וכרטיס העיצוב החופשי — כרטיסי הכיתוב חיים בעורך */
      '.tkeng--editor{display:none}' +
      '.tk3dp__dlgside .tkeng--editor{display:block}' +
      /* דיאלוג מסך מלא — הכרטיסים האמיתיים עוברים פנימה */
      '.tk3dp__dlg{position:fixed;inset:0;z-index:99999;background:#222B3E;display:flex;flex-direction:column;padding:12px;box-sizing:border-box}' +
      '.tk3dp__dlghead{display:flex;align-items:center;gap:14px;margin:0 0 10px}' +
      '.tk3dp__dlglogo{flex:0 0 auto;background:#FBF6E9;border-radius:10px;padding:6px 12px;display:flex;align-items:center}' +
      '.tk3dp__dlglogo img{height:34px;display:block}' +
      '.tk3dp__dlgtitle{font-size:1.6rem;font-weight:700;color:#FBF6E9;flex:1 1 auto}' +
      '.tk3dp__dlgclose{flex:0 0 auto;font:inherit;font-size:1.3rem;font-weight:700;padding:8px 16px;border-radius:999px;border:none;background:#FBF6E9;color:#2E3A54;cursor:pointer}' +
      /* בורר מידה + צבע בתוך העורך */
      '.tk3dp__pick{background:#FBF6E9;border-radius:12px;padding:12px 14px;margin:0 0 10px;border-top:3px solid #c9a24b}' +
      '.tk3dp__pickttl{font-weight:700;color:#2E3A54;font-size:1.35rem;margin:0 0 8px}' +
      '.tk3dp__picklbl{font-weight:600;color:#6e5312;font-size:1.2rem;margin:0 0 5px}' +
      '.tk3dp__sizes{display:flex;gap:7px;flex-wrap:wrap;margin:0 0 10px}' +
      '.tk3dp__sizebtn{font:inherit;font-size:1.25rem;font-weight:600;padding:6px 14px;border-radius:999px;border:1.5px solid #8FA3C4;background:#fff;color:#2E3A54;cursor:pointer}' +
      '.tk3dp__sizebtn.is-on{background:#2E3A54;border-color:#2E3A54;color:#FBF6E9}' +
      /* שורת המידות — בעורך ובעמוד המוצר */
      '.tk3dp__dim{margin:0 0 10px;font-size:1.25rem;color:#6e5312}' +
      '.tk3dp__dim b{font-weight:700;color:#2E3A54}' +
      '.tk3dp__dim span{color:#8a7a55;font-size:1.12rem}' +
      '.tk3dp__pagedim{margin:0 0 14px;padding:9px 13px;border:1px solid #e7d9b4;border-radius:10px;background:#fbf6e9;font-size:1.3rem;color:#6e5312}' +
      '.tk3dp__pagedim b{font-weight:700;color:#2E3A54}' +
      '.tk3dp__pagedim span{color:#8a7a55;font-size:1.15rem}' +
      '.tk3dp__colors{display:flex;gap:10px;flex-wrap:wrap;align-items:center}' +
      '.tk3dp__colorbtn{display:flex;align-items:center;gap:6px;font:inherit;font-size:1.2rem;font-weight:600;padding:5px 12px 5px 7px;border-radius:999px;border:1.5px solid #d9c58f;background:#fff;color:#4a3a12;cursor:pointer}' +
      '.tk3dp__colorbtn i{width:20px;height:20px;border-radius:50%;display:block;border:1px solid rgba(0,0,0,.25)}' +
      '.tk3dp__colorbtn.is-on{border-color:#2E3A54;box-shadow:0 0 0 2px #2E3A54 inset;color:#2E3A54}' +
      '.tk3dp__dlgmain{display:flex;gap:12px;flex:1 1 auto;min-height:0}' +
      '.tk3dp__dlgside{flex:0 0 360px;overflow:auto;box-sizing:border-box;padding:2px}' +
      '.tk3dp__dlgside .tkeng{margin:0 0 10px}' +
      '.tk3dp__dlgside .tk3dp__fs{display:none}' +
      '.tk3dp__dlgside .tk3dp__lead{display:none}' +
      '.tk3dp__dlg .tk3dp__stage{flex:1 1 auto;min-width:0;min-height:0}' +
      '.tk3dp__dlg .tk3dp__canvas{height:100%;border-radius:12px}' +
      '@media(max-width:860px){.tk3dp__dlgmain{flex-direction:column;overflow:auto}.tk3dp__dlg .tk3dp__stage{min-height:44vh;flex:0 0 auto}.tk3dp__dlg .tk3dp__canvas{height:44vh}.tk3dp__dlgside{flex:0 0 auto;order:2}}';
    document.head.appendChild(s);
  }

  var state = { loaded: false, loading: false };

  function loadScript(src) {
    return new Promise(function (res, rej) {
      var s = document.createElement('script');
      s.src = src;
      s.onload = res;
      s.onerror = rej;
      document.head.appendChild(s);
    });
  }

  // פונט החריטה — Taamey David CLM
  var fontReady = false;
  function loadFont(onReady) {
    try {
      var f = new FontFace('TaameyDavidCLM', 'url(' + FONT_URL + ')');
      f.load().then(function (face) {
        document.fonts.add(face);
        fontReady = true;
        onReady();
      }).catch(function () {});
    } catch (e) {}
  }

  function boot() {
    var toggle = document.getElementById('tkeng-toggle');
    var firstTa = document.querySelector('.tkloc__ta');
    var form = document.querySelector('product-form form[action*="/cart/add"], form[action*="/cart/add"][data-type="add-to-cart-form"]');
    if (!toggle || !firstTa || !form) return false;
    var wrapCard = toggle.closest('.tkeng');
    var engBody = wrapCard ? wrapCard.querySelector('.tkeng__body') : null;
    if (!engBody) return false;

    css();
    var panel = el('div', 'tk3dp');
    panel.dir = RTL ? 'rtl' : 'ltr';
    panel.appendChild(el('p', 'tk3dp__lead', T.lead));

    var bar = el('div', 'tk3dp__bar');
    var mReal = el('button', 'tk3dp__mode is-on', T.modeReal);
    mReal.type = 'button';
    var mClear = el('button', 'tk3dp__mode', T.modeClear);
    mClear.type = 'button';
    bar.appendChild(mReal);
    bar.appendChild(mClear);
    panel.appendChild(bar);

    var stage = el('div', 'tk3dp__stage');
    var cv = el('canvas', 'tk3dp__canvas');
    stage.appendChild(cv);
    var loadMsg = el('div', 'tk3dp__load', T.loading);
    stage.appendChild(loadMsg);
    var hint = el('div', 'tk3dp__hint', T.hint);
    hint.style.display = 'none';
    stage.appendChild(hint);
    panel.appendChild(stage);
    var note = el('p', 'tk3dp__note', T.note);
    panel.appendChild(note);

    // הפאנל אחרי שורות המיקומים, בתוך גוף הווידג'ט
    var fieldsEl = engBody.querySelector('.tkeng__fields');
    if (fieldsEl && fieldsEl.parentNode === engBody) engBody.insertBefore(panel, fieldsEl.nextSibling);
    else engBody.appendChild(panel);

    // ---- כפתור כניסה גדול לעורך — לפני כרטיס הכיתוב ----
    var cta = el('button', 'tk3dp__cta');
    cta.type = 'button';
    cta.dir = RTL ? 'rtl' : 'ltr';
    var ctaB = document.createElement('b');
    ctaB.textContent = T.cta;
    var ctaS = document.createElement('span');
    ctaS.textContent = T.ctaSub;
    var ctaI = document.createElement('i');
    cta.appendChild(ctaB);
    cta.appendChild(ctaS);
    cta.appendChild(ctaI);
    wrapCard.parentNode.insertBefore(cta, wrapCard);
    cta.addEventListener('click', function () {
      if (!toggle.checked) {
        toggle.checked = true;
        toggle.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        open();
      }
      openDlg();
    });

    // כרטיסי הכיתוב לא מוצגים בעמוד המוצר — רק בתוך העורך
    wrapCard.classList.add('tkeng--editor');
    var front0 = document.getElementById('tkeng-front');
    var frontCard0 = front0 ? front0.closest('.tkeng') : null;
    if (frontCard0) frontCard0.classList.add('tkeng--editor');
    var design0 = document.getElementById('tkeng-design');
    var designCard0 = design0 ? design0.closest('.tkeng') : null;
    if (designCard0) designCard0.classList.add('tkeng--editor');

    // סיכום חי מתחת לכפתור: כמה כיתובים, כמה זה עולה
    var PRICE = C.price || 49;
    function ctaSummary() {
      var n = 0, base = false, box = false;
      for (var i = 0; i < LOCS.length; i++) {
        var ta = document.querySelector('.tkloc__ta[data-tkloc-ta="' + i + '"]');
        if (ta && ta.value.replace(/\s/g, '')) {
          n++;
          if (i <= 2) base = true; else box = true;
        }
      }
      var dcb = document.getElementById('tkeng-design');
      var dta = dcb ? dcb.closest('.tkeng').querySelector('.tkeng__ta') : null;
      var hasDesign = !!(dcb && dcb.checked && dta && dta.value.replace(/\s/g, ''));
      var eng = toggle.checked && n > 0;
      var on = eng || hasDesign;
      cta.classList.toggle('is-set', on);
      ctaB.textContent = on ? T.ctaEdit : T.cta;
      if (!on) return;
      var bits = [];
      if (eng) {
        var zones = (base ? 1 : 0) + (box ? 1 : 0);
        bits.push((n === 1 ? T.sumOne : T.sumMany.replace('[k]', String(n))) +
          ' · +' + (PRICE * zones) + ' ₪' + (zones === 2 ? ' (' + T.sumBoth + ')' : ''));
      }
      if (hasDesign) bits.push(T.sumDesign);
      ctaI.textContent = '✓ ' + bits.join(' · ');
    }
    setInterval(ctaSummary, 400);

    var mode = 'real';
    function setMode(m) {
      mode = m;
      mReal.classList.toggle('is-on', m === 'real');
      mClear.classList.toggle('is-on', m === 'clear');
    }
    mReal.addEventListener('click', function () { setMode('real'); });
    mClear.addEventListener('click', function () { setMode('clear'); });

    // ---- פורטלים ----
    function portal(elm) {
      var ph = document.createElement('div');
      ph.style.display = 'none';
      elm.parentNode.insertBefore(ph, elm);
      return { el: elm, ph: ph };
    }
    function unportal(p) {
      p.ph.parentNode.insertBefore(p.el, p.ph);
      p.ph.remove();
    }

    // ---- בורר מידה + צבע שמעדכן את המוצר עצמו ----
    var pickerRefs = null;
    var SIZE_ORDER = ['קטן', 'בינוני', 'גדול', 'ענק', 'Small', 'Medium', 'Large', 'Giant'];
    function currentInfo() {
      var idInput = form.querySelector('input[name="id"]');
      return idInput && C.limits ? C.limits[idInput.value] : null;
    }
    function setVariant(sizeLbl, colorLbl) {
      // דרך בורר הווריאנטים של התבנית (radio) — כך המחיר, הגלריה וה-URL מתעדכנים
      function clickOpt(val) {
        var ins = document.querySelectorAll('input[type="radio"]');
        for (var i = 0; i < ins.length; i++) {
          if (ins[i].value === val) {
            if (!ins[i].checked) ins[i].click();
            return true;
          }
        }
        return false;
      }
      var okS = clickOpt(sizeLbl);
      var okC = clickOpt(colorLbl);
      if (!okS || !okC) {
        var idInput = form.querySelector('input[name="id"]');
        for (var k in C.limits) {
          var v = C.limits[k];
          if (v && v.o1 === sizeLbl && v.o2 === colorLbl && v.eng !== 'עם') {
            idInput.value = k;
            idInput.dispatchEvent(new Event('change', { bubbles: true }));
            break;
          }
        }
      }
    }
    function fillDim(node, info) {
      if (!node) return;
      var t = info && info.o1 ? dimText(info.o1) : '';
      node.textContent = '';
      if (!t) return;
      node.appendChild(document.createTextNode(T.dimLbl + ': '));
      var b = document.createElement('b');
      b.textContent = t;
      node.appendChild(b);
      node.appendChild(document.createTextNode(' '));
      var sp = document.createElement('span');
      sp.textContent = '(' + T.dimOrder + ')';
      node.appendChild(sp);
    }
    function syncPicker() {
      if (!pickerRefs) return;
      var info = currentInfo();
      for (var s in pickerRefs.size) pickerRefs.size[s].classList.toggle('is-on', !!info && info.o1 === s);
      for (var c in pickerRefs.color) pickerRefs.color[c].classList.toggle('is-on', !!info && info.o2 === c);
      fillDim(pickerRefs.dim, info);
    }
    setInterval(syncPicker, 400);

    // ---- שורת המידות בעמוד המוצר, מתחת לבורר הגודל של התבנית ----
    // התבנית מרנדרת מחדש את בורר הווריאנטים בכל החלפת גודל ומוחקת אלמנטים מוזרקים,
    // ולכן בודקים בכל מחזור שהשורה עדיין מחוברת ומחזירים אותה למקומה.
    var pageDim = el('div', 'tk3dp__pagedim');
    pageDim.dir = RTL ? 'rtl' : 'ltr';
    function sizeFieldset() {
      var sets = document.querySelectorAll('fieldset, .product-form__input');
      for (var i = 0; i < sets.length; i++) {
        var lg = sets[i].querySelector('legend, .form__label');
        var lt = lg ? (lg.textContent || '') : '';
        if (lt.indexOf('גודל') !== -1 || /\bsize\b/i.test(lt)) return sets[i];
      }
      return null;
    }
    function placePageDim() {
      if (pageDim.isConnected) return;
      var host = sizeFieldset();
      if (host && host.parentNode) host.parentNode.insertBefore(pageDim, host.nextSibling);
      else if (cta.parentNode) cta.parentNode.insertBefore(pageDim, cta);
    }
    function syncPageDim() {
      placePageDim();
      fillDim(pageDim, currentInfo());
    }
    syncPageDim();
    setInterval(syncPageDim, 400);
    function buildPicker() {
      var box = el('div', 'tk3dp__pick');
      box.dir = RTL ? 'rtl' : 'ltr';
      box.appendChild(el('div', 'tk3dp__pickttl', T.pickTtl));
      var sizes = [], colors = [];
      for (var k in C.limits) {
        var v = C.limits[k];
        if (!v) continue;
        if (v.o1 && sizes.indexOf(v.o1) === -1) sizes.push(v.o1);
        if (v.o2 && colors.indexOf(v.o2) === -1) colors.push(v.o2);
      }
      sizes.sort(function (a, b) {
        var ia = SIZE_ORDER.indexOf(a), ib = SIZE_ORDER.indexOf(b);
        return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
      });
      pickerRefs = { size: {}, color: {} };
      box.appendChild(el('div', 'tk3dp__picklbl', T.pickSize));
      var srow = el('div', 'tk3dp__sizes');
      sizes.forEach(function (s) {
        var b = el('button', 'tk3dp__sizebtn', s);
        b.type = 'button';
        b.addEventListener('click', function () {
          var info = currentInfo();
          setVariant(s, info && info.o2 ? info.o2 : colors[0]);
        });
        srow.appendChild(b);
        pickerRefs.size[s] = b;
      });
      box.appendChild(srow);
      var dimRow = el('div', 'tk3dp__dim');
      dimRow.dir = RTL ? 'rtl' : 'ltr';
      box.appendChild(dimRow);
      pickerRefs.dim = dimRow;
      box.appendChild(el('div', 'tk3dp__picklbl', T.pickColor));
      var crow = el('div', 'tk3dp__colors');
      colors.forEach(function (c) {
        var b = el('button', 'tk3dp__colorbtn');
        b.type = 'button';
        var dot = document.createElement('i');
        dot.style.background = SWATCH[c] || '#999';
        b.appendChild(dot);
        b.appendChild(el('span', null, c));
        b.addEventListener('click', function () {
          var info = currentInfo();
          setVariant(info && info.o1 ? info.o1 : sizes[0], c);
        });
        crow.appendChild(b);
        pickerRefs.color[c] = b;
      });
      box.appendChild(crow);
      syncPicker();
      return box;
    }

    // ---- דיאלוג מסך מלא: הכרטיסים האמיתיים עוברים פנימה ----
    var dlg = null, ports = null;
    function openDlg() {
      if (dlg) return;
      var front770 = document.getElementById('tkeng-front');
      var designCb = document.getElementById('tkeng-design');
      var frontCard = front770 ? front770.closest('.tkeng') : null;
      var designCard = designCb ? designCb.closest('.tkeng') : null;

      dlg = el('div', 'tk3dp__dlg');
      dlg.dir = RTL ? 'rtl' : 'ltr';
      var head = el('div', 'tk3dp__dlghead');
      var logoBox = el('div', 'tk3dp__dlglogo');
      var logoImg = document.createElement('img');
      logoImg.src = LOGO_URL;
      logoImg.alt = 'TIKUN';
      logoBox.appendChild(logoImg);
      head.appendChild(logoBox);
      head.appendChild(el('div', 'tk3dp__dlgtitle', T.dlgTitle));
      var closeBtn = el('button', 'tk3dp__dlgclose', T.fullExit);
      closeBtn.type = 'button';
      head.appendChild(closeBtn);
      dlg.appendChild(head);
      var main = el('div', 'tk3dp__dlgmain');
      var side = el('div', 'tk3dp__dlgside');

      side.appendChild(buildPicker());

      if (frontCard) frontCard.classList.add('tkeng--editor');
      ports = [];
      ports.push(portal(wrapCard)); side.appendChild(wrapCard);
      if (frontCard) { ports.push(portal(frontCard)); side.appendChild(frontCard); }
      if (designCard) { ports.push(portal(designCard)); side.appendChild(designCard); }
      ports.push(portal(stage)); main.appendChild(side); main.appendChild(stage);
      dlg.appendChild(main);
      document.body.appendChild(dlg);
      document.body.style.overflow = 'hidden';
      closeBtn.addEventListener('click', closeDlg);
      var ta0 = wrapCard.querySelector('.tkloc__ta');
      if (ta0) setTimeout(function () { ta0.focus(); }, 60);
    }
    function closeDlg() {
      if (!dlg) return;
      for (var i = ports.length - 1; i >= 0; i--) unportal(ports[i]);
      ports = null;
      pickerRefs = null;
      dlg.remove();
      dlg = null;
      document.body.style.overflow = '';
      // יצאו בלי לכתוב כלום — לא משאירים את הכיתוב מסומן (הכרטיס מוסתר בעמוד)
      var any = false;
      for (var j = 0; j < LOCS.length; j++) {
        var ta = document.querySelector('.tkloc__ta[data-tkloc-ta="' + j + '"]');
        if (ta && ta.value.replace(/\s/g, '')) { any = true; break; }
      }
      if (!any && toggle.checked) {
        toggle.checked = false;
        toggle.dispatchEvent(new Event('change', { bubbles: true }));
      }
      // בקשת עיצוב מסומנת אך ריקה — מנקים, אחרת ההוספה לסל תיחסם על שדה מוסתר
      var dcb = document.getElementById('tkeng-design');
      if (dcb && dcb.checked) {
        var dta = dcb.closest('.tkeng').querySelector('.tkeng__ta');
        if (!dta || !dta.value.replace(/\s/g, '')) {
          dcb.checked = false;
          dcb.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      ctaSummary();
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && dlg) closeDlg();
    });

    function open() {
      if (state.loaded || state.loading) return;
      state.loading = true;
      loadFont(function () { if (window.__tkRedraw) window.__tkRedraw(); });
      SCRIPTS.reduce(function (p, src) { return p.then(function () { return loadScript(src); }); }, Promise.resolve())
        .then(function () { init(); })
        .catch(function () { loadMsg.textContent = T.err; });
    }
    toggle.addEventListener('change', function () {
      if (toggle.checked) open();
      else if (dlg) closeDlg();
    });
    if (toggle.checked) open();

    function init() {
      var THREE = window.THREE;
      var renderer = new THREE.WebGLRenderer({ canvas: cv, antialias: true, alpha: true });
      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
      renderer.outputEncoding = THREE.sRGBEncoding;
      var scene = new THREE.Scene();
      var camera = new THREE.PerspectiveCamera(35, 2, 1, 3000);
      camera.position.set(150, 55, 195);
      var controls = new THREE.OrbitControls(camera, cv);
      controls.enableDamping = true;
      controls.dampingFactor = 0.08;
      controls.target.set(0, 8, 0);
      controls.minDistance = 90;
      controls.maxDistance = 450;
      // המודל להצגה חלול ופתוח מלמטה (הגנה מהעתקה) — לא נותנים למצלמה לרדת מתחת
      controls.maxPolarAngle = Math.PI * 0.53;
      controls.enablePan = true;
      controls.screenSpacePanning = true;
      controls.mouseButtons = { LEFT: THREE.MOUSE.ROTATE, MIDDLE: THREE.MOUSE.PAN, RIGHT: THREE.MOUSE.ROTATE };
      controls.autoRotate = true;
      controls.autoRotateSpeed = 1.6;
      cv.addEventListener('pointerdown', function () { controls.autoRotate = false; });

      scene.add(new THREE.HemisphereLight(0xffffff, 0x55607a, 0.9));
      var d1 = new THREE.DirectionalLight(0xfff4dd, 0.85); d1.position.set(140, 200, 180); scene.add(d1);
      var d2 = new THREE.DirectionalLight(0xffffff, 0.4); d2.position.set(-180, 80, -140); scene.add(d2);
      var d3 = new THREE.DirectionalLight(0xffffff, 0.45); d3.position.set(0, -40, 200); scene.add(d3);
      var d4 = new THREE.DirectionalLight(0xfff4dd, 0.7); d4.position.set(40, 120, -220); scene.add(d4);

      function srgbColor(material, hex) {
        material.color.setHex(hex);
        material.color.convertSRGBToLinear();
      }
      var mat = new THREE.MeshStandardMaterial({ metalness: COLORS[DEFAULT_COLOR].m, roughness: COLORS[DEFAULT_COLOR].r, flatShading: true });
      srgbColor(mat, COLORS[DEFAULT_COLOR].c);
      var matBase = new THREE.MeshStandardMaterial({ metalness: 0.12, roughness: 0.62, flatShading: true });
      srgbColor(matBase, BASE_COLOR);
      // קופסת ההסתרה הפנימית — שחור-חם עמוק, בלי תאורה: נקרא כצל בתוך הקופה
      var matOcc = new THREE.MeshBasicMaterial({ color: 0x0d0805, side: THREE.DoubleSide });

      function isRemovable(o) {
        var n = (o.name || '') + '|' + (o.parent && o.parent.name || '');
        return n.indexOf('BasePlinth') !== -1 || n.indexOf('TopInner') !== -1 || n.indexOf('WM') !== -1;
      }
      function isOccluder(o) {
        var n = (o.name || '') + '|' + (o.parent && o.parent.name || '');
        return n.indexOf('Occluder') !== -1;
      }

      var loader = new THREE.GLTFLoader();
      if (window.MeshoptDecoder) loader.setMeshoptDecoder(window.MeshoptDecoder);
      loader.load(D.glb, function (g) {
        var model = g.scene;
        model.traverse(function (o) { if (o.isMesh) o.material = isOccluder(o) ? matOcc : (isRemovable(o) ? matBase : mat); });
        scene.add(model);
        loadMsg.style.display = 'none';
        state.loaded = true;
      }, undefined, function () { loadMsg.textContent = T.err; });

      // ---- ציור חריטה בגוון המשטח (לא אפור) ----
      function rgbOf(hex) { return [(hex >> 16) & 255, (hex >> 8) & 255, hex & 255]; }
      function carveColors(surfaceHex) {
        var c = rgbOf(surfaceHex);
        var dark = 'rgba(' + Math.round(c[0] * 0.22) + ',' + Math.round(c[1] * 0.22) + ',' + Math.round(c[2] * 0.22) + ',0.92)';
        var lite = 'rgba(' + Math.min(255, Math.round(c[0] * 1.55 + 70)) + ',' + Math.min(255, Math.round(c[1] * 1.55 + 62)) + ',' + Math.min(255, Math.round(c[2] * 1.5 + 55)) + ',0.5)';
        return { dark: dark, lite: lite };
      }
      function fontFor(fs) {
        return (fontReady ? '500 ' : '700 ') + fs + 'px ' + FONT_STACK;
      }
      // ברירת מחדל: הכיתוב גדול כמה שנכנס יפה באזור. sf (50%-100%) רק מקטין ממנו.
      function drawInto(ctx, cvEl, text, wMM, hMM, surfaceHex, sf) {
        var W = 1024;
        var H = Math.max(64, Math.round(W * hMM / wMM));
        cvEl.width = W; cvEl.height = H;
        ctx.clearRect(0, 0, W, H);
        var lines = text.split(/\r?\n/).filter(function (l) { return l.trim(); }).slice(0, 2);
        if (!lines.length) return false;
        var pad = W * 0.035;
        var maxW = W - pad * 2;
        var lineH = H / lines.length;
        var fit = lineH * (lines.length > 1 ? 0.78 : 0.82);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        var cc = carveColors(surfaceHex);
        var scale = sf == null ? 1 : sf;
        for (var i = 0; i < lines.length; i++) {
          var ln = lines[i].trim();
          // הגדלה עד גבול הגובה, ואז כיווץ פרופורציוני אם רחב מדי
          var fs = fit;
          ctx.font = fontFor(fs);
          var tw = ctx.measureText(ln).width;
          if (tw > maxW) {
            fs = Math.max(9, fs * maxW / tw);
            ctx.font = fontFor(fs);
            if (ctx.measureText(ln).width > maxW) {
              fs = Math.max(9, fs * maxW / ctx.measureText(ln).width);
            }
          }
          fs = Math.max(9, fs * scale);
          ctx.font = fontFor(fs);
          var y = lineH * (i + 0.5);
          if (mode === 'real') {
            // שקע: הצללה כהה בגוון המשטח + פס אור חם בקצה התחתון
            ctx.fillStyle = cc.lite;
            ctx.fillText(ln, W / 2, y + fs * 0.07);
            ctx.fillStyle = cc.dark;
            ctx.fillText(ln, W / 2, y);
            ctx.fillStyle = 'rgba(0,0,0,0.28)';
            ctx.fillText(ln, W / 2, y - fs * 0.015);
          } else {
            ctx.fillStyle = 'rgba(0,0,0,0.55)';
            ctx.fillText(ln, W / 2, y + fs * 0.05);
            ctx.fillStyle = 'rgba(248,232,200,0.98)';
            ctx.fillText(ln, W / 2, y);
          }
        }
        return true;
      }

      // ---- מש-י טקסט: אחד לכל מיקום + הכיתוב הקבוע בחזית ----
      function makeTextMesh() {
        var c = document.createElement('canvas');
        var m = new THREE.MeshBasicMaterial({ transparent: true, depthWrite: false, alphaTest: 0.03 });
        var mesh = new THREE.Mesh(new THREE.PlaneGeometry(1, 1), m);
        mesh.visible = false;
        scene.add(mesh);
        return { cv: c, ctx: c.getContext('2d'), mat: m, mesh: mesh };
      }
      function refreshTex(tm) {
        if (tm.mat.map) tm.mat.map.dispose();
        var t = new THREE.CanvasTexture(tm.cv);
        t.anisotropy = 4;
        tm.mat.map = t;
        tm.mat.needsUpdate = true;
      }
      var texts = LOCS.map(function () { return makeTextMesh(); });
      var frontTm = makeTextMesh();
      frontTm.mesh.position.set(LOCS[0].pos[0], LOCS[0].pos[1], LOCS[0].pos[2] - 0.02);

      var camAnim = null;
      function flyTo(camPos, tgt) {
        controls.autoRotate = false;
        camAnim = {
          t: 0,
          c0: camera.position.clone(), c1: new THREE.Vector3(camPos[0], camPos[1], camPos[2]),
          g0: controls.target.clone(), g1: new THREE.Vector3(tgt[0], tgt[1], tgt[2])
        };
      }

      // מעבר מצלמה כשנכנסים לשדה של מיקום
      document.addEventListener('focusin', function (e) {
        var t = e.target;
        if (t && t.classList && t.classList.contains('tkloc__ta')) {
          var i = parseInt(t.getAttribute('data-tkloc-ta'), 10);
          if (LOCS[i]) flyTo(LOCS[i].cam, LOCS[i].tgt);
        }
      });

      function readState() {
        var on = toggle.checked;
        var items = [];
        for (var i = 0; i < LOCS.length; i++) {
          var ta = document.querySelector('.tkloc__ta[data-tkloc-ta="' + i + '"]');
          var rng = document.querySelector('.tkloc__size[data-tkloc-size="' + i + '"]');
          items.push({
            text: on && ta ? ta.value : '',
            sf: rng ? parseInt(rng.value, 10) / 100 : 1
          });
        }
        var customFront = on && !!items[0].text.replace(/\s/g, '');
        var frontKey = '';
        if (!customFront) {
          var f770 = document.getElementById('tkeng-front');
          var fYechi = document.getElementById('tkeng-front-yechi');
          var fTzedaka = document.getElementById('tkeng-front-tzedaka');
          var fNone = document.getElementById('tkeng-front-none');
          if (f770 && f770.checked) frontKey = '770';
          else if (fYechi && fYechi.checked) frontKey = FRONT_YECHI;
          else if (fTzedaka && fTzedaka.checked) frontKey = FRONT_TZEDAKA;
          else if (fNone && fNone.checked) frontKey = '';
          else frontKey = FRONT_FULL;
        }
        var idInput = form.querySelector('input[name="id"]');
        var info = idInput && C.limits ? C.limits[idInput.value] : null;
        var colorName = info && info.o2 && COLORS[info.o2] ? info.o2 : DEFAULT_COLOR;
        return { on: on, items: items, front: frontKey, color: colorName, mode: mode, font: fontReady };
      }

      var lastKey = '';
      var lastFilled = LOCS.map(function () { return false; });
      function redraw() {
        var st = readState();
        var cc = COLORS[st.color];
        srgbColor(mat, cc.c); mat.metalness = cc.m; mat.roughness = cc.r;

        var any = false;
        for (var i = 0; i < LOCS.length; i++) {
          var L = LOCS[i];
          var it = st.items[i];
          var surface = L.base ? BASE_COLOR : cc.c;
          var has = !!it.text.replace(/\s/g, '') && drawInto(texts[i].ctx, texts[i].cv, it.text, L.w, L.h, surface, it.sf);
          texts[i].mesh.visible = has;
          if (has) {
            refreshTex(texts[i]);
            texts[i].mesh.geometry.dispose();
            texts[i].mesh.geometry = new THREE.PlaneGeometry(L.w, L.h);
            texts[i].mesh.position.set(L.pos[0], L.pos[1], L.pos[2]);
            texts[i].mesh.rotation.set(0, L.rotY, 0);
            any = true;
            if (!lastFilled[i] && st.on) flyTo(L.cam, L.tgt);
          }
          lastFilled[i] = has;
        }
        // הכיתוב הקבוע בחזית
        if (st.front) {
          drawInto(frontTm.ctx, frontTm.cv, st.front, LOCS[0].w, LOCS[0].h, BASE_COLOR, 1);
          refreshTex(frontTm);
          frontTm.mesh.geometry.dispose();
          frontTm.mesh.geometry = new THREE.PlaneGeometry(LOCS[0].w, LOCS[0].h);
          frontTm.mesh.visible = true;
        } else {
          frontTm.mesh.visible = false;
        }
        hint.style.display = st.on && !any ? 'block' : 'none';
      }
      window.__tkRedraw = redraw;

      function sync() {
        var st = readState();
        var key = JSON.stringify(st);
        if (key !== lastKey) {
          lastKey = key;
          redraw();
        }
      }
      setInterval(sync, 300);

      function resize() {
        var w = cv.clientWidth, h = cv.clientHeight;
        if (!w || !h) return;
        var pr = renderer.getPixelRatio();
        if (cv.width !== Math.round(w * pr) || cv.height !== Math.round(h * pr)) {
          renderer.setSize(w, h, false);
          camera.aspect = w / h;
          camera.updateProjectionMatrix();
        }
      }

      function tick() {
        requestAnimationFrame(tick);
        resize();
        if (camAnim) {
          camAnim.t += 0.045;
          var k = camAnim.t >= 1 ? 1 : 1 - Math.pow(1 - camAnim.t, 3);
          camera.position.lerpVectors(camAnim.c0, camAnim.c1, k);
          controls.target.lerpVectors(camAnim.g0, camAnim.g1, k);
          if (camAnim.t >= 1) camAnim = null;
        }
        controls.update();
        renderer.render(scene, camera);
      }
      tick();
      sync();
    }
    return true;
  }

  function start() {
    if (boot()) return;
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (boot() || tries > 60) clearInterval(t);
    }, 300);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
